import React, { useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";
import ContactForm, { ContactFormHandle } from "../ContactForm/ContactForm";
import { Contact, ProjectVariable } from "../types/Contact";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  contacts: Contact[];
  clientId: string | null;
  projectVariableDefinitions: ProjectVariable[];
}

const Edit: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  contacts,
  clientId,
  projectVariableDefinitions,
}) => {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const contact: Contact = routeLocation.state?.contact;
  const submitRef = useRef<ContactFormHandle>(null);
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  navigate(`/projects/${projectId}/project_contacts`, {
                    state: null,
                  })
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={9}>
              Edit Contact
            </Col>
            {permission === "manage" && projectStatus === "building" && (
              <Col>
                <Button
                  className="squareGreenButton"
                  onClick={() => submitRef.current?.saveContact()}
                >
                  Save
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        <Card.Body>
          <ContactForm
            ref={submitRef}
            projectId={projectId}
            contact={contact}
            contacts={contacts}
            clientId={clientId}
            projectVariableDefinitions={projectVariableDefinitions}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default Edit;
